import React from 'react';
import { IOM_Info } from 'main/services/OrderManager';
import { BaseApiPostData, FormChanges } from 'src/interfaces';
import { handleFormChanges } from 'src/helpers';
import { Col, Form, Input, InputNumber, Row } from 'antd';

interface IOrderEditDeliveriesProps {
    order: IOM_Info;
    loading: boolean;
    onChange: (values: BaseApiPostData) => void;
}

export const OrderEditDeliveries: React.FC<IOrderEditDeliveriesProps> = ({ order, onChange, loading }) => {
    const handleChange = handleFormChanges((changedValues: FormChanges, allValues: FormChanges) => {
        onChange(allValues);
    });

    return (
        <Form layout={'vertical'} onValuesChange={handleChange} initialValues={order} disabled={loading}>
            <Row gutter={30}>
                <Col xs={24} sm={24} md={24} lg={8}>
                    <Form.Item name={'region'}
                               label="Область"
                               hasFeedback
                    >
                        <Input/>
                    </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={24} lg={8}>
                    <Form.Item name={'city'}
                               label="Місто"
                               hasFeedback
                    >
                        <Input/>
                    </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={24} lg={8}>
                    <Form.Item name={'street'}
                               label="Вулиця"
                               hasFeedback
                    >
                        <Input/>
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={30}>
                <Col xs={24} sm={24} md={24} lg={8}>
                    <Form.Item name={'street_house'}
                               label="Номер будинку"
                               hasFeedback
                    >
                        <InputNumber style={{ width: '100%' }}/>
                    </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={24} lg={8}>
                    <Form.Item name={'np_warehouse'}
                               label="Відділення Нової Пошти №"
                               hasFeedback
                    >
                        <InputNumber style={{ width: '100%' }}/>
                    </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={24} lg={8}>
                    <Form.Item name={'ttn'}
                               label="ТТН"
                               hasFeedback
                    >
                        <InputNumber style={{ width: '100%' }}/>
                    </Form.Item>
                </Col>
            </Row>
        </Form>
    );
};
